import { render } from "./readydemandModel.vue?vue&type=template&id=4ccb57f8"
import script from "./readydemandModel.vue?vue&type=script&lang=js"
export * from "./readydemandModel.vue?vue&type=script&lang=js"

import "./readydemandModel.vue?vue&type=style&index=0&id=4ccb57f8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__